import { render } from "./BourseDossardsView.vue?vue&type=template&id=b744fa4a"
import script from "./BourseDossardsView.vue?vue&type=script&lang=js"
export * from "./BourseDossardsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__